import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hotel-detail-loader',
  templateUrl: './hotel-detail-loader.component.html',
  styleUrls: ['./hotel-detail-loader.component.scss']
})
export class HotelDetailLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
